import { useEffect, useState } from 'react';

type Theme = 'dark' | 'light';

function readTheme(): Theme {
  try {
    return (localStorage.getItem('shum-theme-v3') as Theme) || 'dark';
  } catch {
    return 'dark';
  }
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(readTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try {
      localStorage.setItem('shum-theme-v3', theme);
    } catch {
      /* noop */
    }
  }, [theme]);

  return (
    <div className="theme-toggle" role="group" aria-label="Тема">
      <button aria-pressed={theme === 'dark'} onClick={() => setTheme('dark')}>
        Ночь
      </button>
      <button aria-pressed={theme === 'light'} onClick={() => setTheme('light')}>
        День
      </button>
    </div>
  );
}

// Apply theme as early as possible (called from main.tsx before React renders).
export function initTheme(): void {
  document.documentElement.setAttribute('data-theme', readTheme());
}
